<template>
  <div class="w100 pt20 pb20 pl20 p20" style="background-color: none" v-loading="loading">
    <section class="w100 flex-box" style="flex-direction: row;">
      <div class="flex-1" style="max-width: 890px; overflow: hidden;">
        <p class="w100 font-16 blue">服务说明</p>
        <div class="w100 pt10 pb10 pl20 pr20">
          <p class="font-14" v-if='insData.msg' v-html="insData.msg" style="line-height: 25px;"></p>
          <p class="w100 grey tx-c" v-else style="height: 100px; line-height: 100px;">暂无服务说明</p>
          <div class="mt20" v-if="insData.img !== ''">
            <el-image style="width: 100%" fit="fill" :src="insData.img" :preview-src-list="[insData.img]"></el-image>
          </div>
          <div class="w100 grey tx-c" v-else style="height: 100px; line-height: 100px;">暂无相关流程图片</div>
        </div>

        <el-divider></el-divider>
        <p class="w100 font-16 blue">相关文件</p>
        <div class="w100 pt10 pb10 pl20 pr20">
          <!-- <p class="w100 grey tx-c" v-show="insData.dlList.length == 0">暂无相关文件</p> -->
          <el-table class="w100 table" :show-header="false" header-row-class-name="table-head" stripe :data="insData.dlList">
            <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
            <el-table-column header-align="center" prop="relatedFileName" label="文件"></el-table-column>
            <el-table-column align="center" label="操作" width="">
              <template slot-scope="scope">
                <span class="cu-p hover" @click="download(scope.row)">下载</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-divider></el-divider>
        <p class="w100 font-16 blue">注意事项</p>
        <div class="w100 pt10 pb10 pl20 pr20" v-if="insData.qaList.length > 0">
          <!-- <p class="w100 grey tx-c" v-show=" == 0">暂无注意事项</p> -->
          <div class="mb20" v-for="(item, index) in insData.qaList" :key="index">
            <p class="font-16 bold">{{ index + 1 }}、{{ item.question }}</p>
            <p class="pl20 pt10 font-14" v-html="item.answer"></p>
          </div>
        </div>
        <div class="w100 grey tx-c" v-else style="height: 100px; line-height: 100px;">暂无注意事项</div>
      </div>

      <div class="ml20 mr20" style="width: 250px;">
        <div class="w100 pt20 pb20 pl20 pr20 card-shadow">
          <section class="pb20">
            <p class="font-16 mb10 blue">服务对象：</p>
            <p class="pl20 font-14" v-if="insData.group">{{ insData.group }}</p>
          </section>
          <section class="pb20">
            <p class="font-16 mb10 blue">负责部门：</p>
            <p class="pl20 font-14" v-html="insData.dept"></p>
          </section>
          <section class="pb20">
            <p class="font-16 mb10 blue">联系人：</p>
            <p class="pl20 font-14" v-html="insData.telPerson"></p>
          </section>
          <section class="pb20">
            <p class="font-16 mb10 blue">联系电话：</p>
            <p class="pl20 font-14" v-html="insData.tel"></p>
          </section>
          <section class="pb20">
            <p class="font-16 mb10 blue">办理时间：</p>
            <p class="pl20 font-14" v-html="insData.date"></p>
          </section>
          <section class="pb20">
            <p class="font-16 mb10 blue">办理地点：</p>
            <p class="pl20 font-14" v-html="insData.address"></p>
          </section>
        </div>

        <div class="mt20 w100 pt20 pb20 pl20 pr20 card-shadow">
          <MarkCard />
        </div>
      </div>
    </section>
    <!-- <p v-else class="w100 tx-c grey pt20 pb20">该服务暂无使用说明！</p> -->
    <a ref="download" :href="href" target="_black"></a>
  </div>
</template>

<script>
import MarkCard from "@/components/public/MarkCard";

export default {
  name: "ApprovalInstructions",
  components: {
    MarkCard
  },
  props: [],
  data() {
    return {
      loading: false,
      insData: {
        msg: "",
        img: "",
        group: "",
        dept: "",
        telPerson: "",
        tel: "",
        date: "",
        address: "",
        dlList: [],
        qaList: []
      },
      href: "",
      downUrl: this.$http.defaults.baseURL // 下载地址
    };
  },
  computed: {},
  created() {
    this.fetchInsData();
  },
  mounted() {},
  destroyed() {},
  methods: {
    fetchInsData() {
      this.loading = true;

      this.$http
        .get("/instruction/detail", {
          params: {
            serveId: this.$route.params.serveId
          }
        })
        .then(({ data }) => {
          if (data.resCode == 0) {
            let serveInfo = data.resData.serveInstructions;
            
            this.insData = {
              msg: serveInfo.serveInstruction ? serveInfo.serveInstruction : '',
              img: data.resData.processPhoto ? data.resData.processPhoto.fileUrl : '',
              // group: "教职工，本科生，研究生，游客",
              dept: serveInfo.chargeDept ? serveInfo.chargeDept : '',
              telPerson: serveInfo.contactName ? serveInfo.contactName : '',
              tel: serveInfo.contactPhone ? serveInfo.contactPhone : '',
              date: serveInfo.handleTime ? serveInfo.handleTime : '',
              address: serveInfo.handleAddr ? serveInfo.handleAddr : '',
              dlList: data.resData.serveFile.length > 0 ? data.resData.serveFile : [],
              qaList: data.resData.qa.length > 0 ? data.resData.qa : []
            };
            
            this.loading = false;
            this.$nextTick(() => {
              this.fetchServeDetail();
            });
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchServeDetail() {
      this.loading = true;

      this.$http
        .get("/hallServe/serveDetail", {
          params: {
            serveId: this.$route.params.serveId
          }
        })
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.insData.group = this.serveSubjectToString(
              data.resData.serve.serveTargetList
            );
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    serveSubjectToString(arr) {
      const newArr = arr.map(val => val.targetName);
      return newArr.join("、");
    },
    download(row) {
      this.axios({
        url: this.downUrl + "/serveFile/downloadFile",
        method: 'get',
        params: {
          id: row.id
        },
        responseType: 'blob'     //接收类型设置，否者返回字符型
      })
      .then(res => {           //定义文件名等相关信息
        let blob = res.data
        let reader = new FileReader()
        let fileName = res.headers['content-disposition'].split(";")[1].split("=")[1]
        reader.readAsDataURL(blob)
        // ie
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          window.navigator.msSaveBlob(blob, res.headers['content-disposition'].split('=')[1]);
        }
        else {
          reader.onload = (e) => {
            const a = document.createElement('a')
            a.download = fileName
            a.href = e.target.result
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
          }
        }
      })
      .catch( () => {
        this.$message.error("网络错误，请重新刷新");
      })
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
</style>
